import script from "./GoalsSlider.vue?vue&type=script&lang=ts&setup=true"
export * from "./GoalsSlider.vue?vue&type=script&lang=ts&setup=true"

import "./GoalsSlider.vue?vue&type=style&index=0&id=51d47578&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-51d47578"]])

export default __exports__